
    import '/opt/buildhome/repo/packages/x/components/notification/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["notification-demo-hooks","notification-demo-duration","notification-demo-close_tag","notification-demo-static-method"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/notification/index.en-US.md?type=demo')
};